import { render, staticRenderFns } from "./ReleasesOtherIdsReadOnlyPanel.vue?vue&type=template&id=f971b510"
import script from "./ReleasesOtherIdsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesOtherIdsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./ReleasesOtherIdsReadOnlyPanel.vue?vue&type=style&index=0&id=f971b510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports